import { SET_DELIVERY_TYPE } from '@/src/modules/build-a-card/constants'
import { EMAIL_DELIVERY, TEXT_DELIVERY } from '@/src/modules/pg-plus/constants'
import { styled } from '@/src/stitches.config'
import { useGiftQuantityContext } from '@/src/common/contexts/GiftQuantityContext'
import Button from '@/src/common/components/marketing/buttons/Button'
import { sendBasicEvent } from '@/src/common/utilities/gtag'
import { HeaderParagraphText } from '@/src/modules/build-a-card/StyledComponents'
import { FieldWrapper } from '@/src/common/components/elements/Forms/StyledComponents'

const DeliverySelectButton = styled(Button, {
    width: '100% !important',
    px: '10px !important',
    br: '5px !important',
    fontSize: '1rem !important',
})
const DeliverSelectButtonsWrap = styled('div', {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
})

type TDeliverMethodInput = {
    analyticsFlowType: string
    label?: string
    style?: object
}

const SelectDeliveryMethod = ({
    label,
    style = {},
    analyticsFlowType,
}: TDeliverMethodInput) => {
    const { dispatch, giftState } = useGiftQuantityContext()
    const { deliveryType } = giftState

    return (
        <FieldWrapper style={style}>
            <HeaderParagraphText>
                {label ?? 'Choose a delivery method'}
            </HeaderParagraphText>
            <DeliverSelectButtonsWrap>
                <DeliverySelectButton
                    label={'Deliver by Text'}
                    onClick={() => {
                        dispatch({
                            type: SET_DELIVERY_TYPE,
                            payload: { type: TEXT_DELIVERY },
                        })

                        const isCurrentType = deliveryType === TEXT_DELIVERY
                        !isCurrentType &&
                            sendBasicEvent('select_gift_delivery', {
                                flow: 'Build A Card',
                                type: analyticsFlowType,
                                delivery_type: TEXT_DELIVERY,
                            })
                    }}
                    variant={
                        deliveryType === TEXT_DELIVERY
                            ? 'graySquareButtonActive'
                            : 'graySquareButton'
                    }
                    type={'button'}
                    name={'deliveryMethod'}
                    data-testid={'text-button'}
                />
                <DeliverySelectButton
                    label={'Deliver by Email'}
                    onClick={() => {
                        dispatch({
                            type: SET_DELIVERY_TYPE,
                            payload: { type: EMAIL_DELIVERY },
                        })

                        const isCurrentType = deliveryType === EMAIL_DELIVERY
                        !isCurrentType &&
                            sendBasicEvent('select_gift_delivery', {
                                flow: 'Build A Card',
                                type: analyticsFlowType,
                                delivery_type: EMAIL_DELIVERY,
                            })
                    }}
                    variant={
                        deliveryType === EMAIL_DELIVERY
                            ? 'graySquareButtonActive'
                            : 'graySquareButton'
                    }
                    type={'button'}
                    name={'deliveryMethod'}
                    data-testid={'email-button'}
                />
            </DeliverSelectButtonsWrap>
        </FieldWrapper>
    )
}
export default SelectDeliveryMethod
